import { jssdkshare } from '@/api/api.js'
import {getDefShareInfo} from '@/api/person'
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'
import { WHITE_PATHS } from '@/store/mutation-types'
export function getShareInfo (to, system, personal) {
  if (WHITE_PATHS.indexOf(to.path) !== -1) {
    return
  }
  // 如果分享的内容会根据情况变化，那么这里可以传入分享标题及url
  // let curHref = system === 'ios' ? window.entryUrl : `${process.env.viewURL}${process.env.BASE_URL}${to.fullPath}`
  let curHref = `${process.env.viewURL}${process.env.BASE_URL}${to.fullPath}`
  console.log(curHref)
  let paramsData = {// 请求参数
    url: curHref,
  }
  jssdkshare(paramsData).then(res => {
    let data = res.data
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data.appId, // 必填，公众号的唯一标识，填自己的！
      timestamp: data.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名，见附录1
      jsApiList: [
        'onMenuShareAppMessage'
      ]
    })
    wx.ready(function () {
      getDefShareInfo().then(res => {
        to.query && delete to.query.code
        curHref = `${process.env.viewURL}${to.path}`
        curHref = curHref + (((curHref.indexOf('?') > 0) ? '&' : '?') + `qrCode=${personal.inv_code}&pid=${personal.id}`)
        for (let i in to.query) {
          if (i !== 'qrCode' && i !== 'pid') {
            curHref += `&${i}=${to.query[i]}`
          }
        }
        wx.onMenuShareAppMessage({
          title: res.data.title,
          desc: res.data.desc,
          link: curHref,
          imgUrl: res.data.cover,
          success: function () {
            console.log('分享成功')
          },
          cancel: function () {
            console.log('取消分享')
          }
        })
        // 分享给朋友
      })
    })
  })
}

export function handlePay (res) {
  // 拿到后端给的这些数据
  let wxData = res.data.pay_res.payInfo

  let params = {
    url: window.location.href
  }
  jssdkshare(params).then(res => {
    let data = res.data
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data.appId, // 必填，公众号的唯一标识，填自己的！
      timestamp: data.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名，见附录1
      jsApiList: [
        'chooseWXPay'
      ]
    })

    wx.ready(function () {
      wx.chooseWXPay({
        timestamp: wxData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: wxData.nonceStr, // 支付签名随机串，不长于 32 位
        package: wxData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: wxData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: wxData.paySign, // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
          Toast('支付成功')
        },
        // 支付取消回调函数
        cancel: function (res) {
          Toast('取消支付')
        },
        fail: function (res) {
        }
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/wxConfig.js